import React from 'react'
import { Document, Page, StyleSheet, View, Text, Image } from "@react-pdf/renderer";
import { limitLength, displayInfo } from './pdfFunctions'
import listaDoencas from 'Ficha/components/listaDoencas'
import logo from 'assets/img/logo2.jpg'
import coopanest from "assets/img/coopanest2.jpg";
import itajuba from "assets/img/itajuba2.jpeg";

function getLogo(logoName) {
  let logoToUse = logo;
  if (logoName === "coopanest") {
    logoToUse = coopanest;
  } 
  if (logoName === "itajuba") {
    logoToUse = itajuba
  }

  return logoToUse;
}

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    justifyContent: 'space-around',
    backgroundColor: 'white',
    fontSize: '8pt',
    padding: '1cm',
  },
  logo: {
    width: 70,
    height: 30,
  },
  title:{
    fontSize: '15pt',
  },
  doctorName:{
    fontSize: '10pt',
    margin: 'auto'
  },
  subtitle:{
    margin: '0pt 0pt 2pt 5pt',
  },
  data: {
    fontSize: '12pt',
    color: 'darkblue'
  },
  blankspace1: {
    height: 4,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    maxWidth: '100%',
    marginBottom: 4,
  },
  fixedRow: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    margin: 0,
    maxWidth: '100%',
    marginBottom: 5,
  },
  item: {
    flexDirection: 'row',
    maxWidth: '100%',
  },
  itemRightMargin: {
    flexDirection: 'row',
    maxWidth: '100%',
    marginRight: '7pt',
  },
  itemExam:{
    flexDirection: 'row',
    width: 85,
  },
  label: {
    fontSize: '6pt',
    marginRight: 2,
  },
  textView: {
    maxWidth: '100%',
  },
  text: {
    color: 'darkblue',
  },
  block: {
    border: '1pt solid black',
    borderRadius: 3,
    padding: 5,
    paddingBottom: 3,
    margin: 0,
    marginBottom: 5,
  },
  stamp:{
    margin: '0 auto',
    fontSize:'6pt',
    textAlign: 'center',
  }
});


const fichaPdf = ({ nome, data, idade, sexo, dataNascimento, profissao, hospital, convenio,
                  procedimentos, cirurgiao, peso, altura, imc, pesoIdeal,
                  pesoPredito, pesoAjustado, procedimentosPrevios,
                  anestesiasPrevias, eventosAdversos, alergias, comorbidade, has,
                  icc, arritmia, marcapasso, coronariopatia, iam, valvopatia, dvp,
                  cefaleia, avc, convulsao, psiq, lnp, medular, tabagismo, asma,
                  dpoc, saos, ivas, tb, drge, ulcera, gastrite, vomitos, hepatopatia,
                  etilismo, dm1, dm2, hipotireoidismo, hipertireoidismo, obesidade,
                  dislipidemia,
                  ira, irc, dialise, calculo, dhe, transfusao, anemia, coagulopatia,
                  tvp, lombalgia, artrite, distrofia, artrose, outrasComorbidades,
                  medicamentos, exameFisico, exameFisicoAlterado, pa, fc, fr, spo2,
                  temp, dor, mallampati, dtm, dem, mobilidadeCervical, aberturaOral,
                  proteseDentaria, vad, hb, ht, hm, leuco, plt, fibrinogenio, tc,
                  ts, tp, inr, ttpa, ap, ureia, creat, na, k, ca, mg, glicemia,
                  hba1c, ast, alt, bil, prot, ecg, eco, radiografia, te, outrosExames,
                  apto, uti, hemocomponentes, hemoTexto, avalEspecialidades,
                  anotacoes, anestesiaProposta, jejum, prescricao, orientacoes,
                  asa, adversosPadrao, alergiasPadrao, anestesiasPadrao,
                  comorbidadesPadrao, medicamentosPadrao, procedimentosPadrao,
                  examePadrao, nomeExibicao, crm, groupName, broncoaspiracao, trombose,
                  sangramento, logoName
                  }) => (

  <Document title="APA" author={nome} creator="www.avaliacaopreanestesica.com">
    <Page style={styles.page} wrap={false}>
      <View style={styles.row}>
          <View><Image style={styles.logo} src={getLogo(logoName)}/></View>
          <View style={styles.textView}>
            <Text style={styles.title}>FICHA DE AVALIAÇÃO PRÉ-ANESTÉSICA</Text>
            <Text style={styles.doctorName}>
              {groupName ? groupName : (nomeExibicao ? nomeExibicao : 'www.avaliacaopreanestesica.com')}
              {!groupName && crm && ` CRM: ${crm}`} 
            </Text>
          </View>
          <View style={styles.textView}><Text style={styles.data}>{data.toDate().toLocaleDateString()}</Text></View>
      </View>
{/* --> IDENTIFICAÇÃ0 <-- */}
      <View style={styles.row}>
      <View style={[styles.block, { flexGrow: 3, maxWidth: '82%' }]}>
        <View style={styles.row}>
          <View style={styles.item}>
            <View style={styles.labelView}><Text style={styles.label}>Nome: </Text></View>
            <View style={styles.textView}><Text style={styles.text}>{limitLength(nome, 50)}</Text></View>
          </View>
          <View style={styles.item}>
            <View style={styles.labelView}><Text style={styles.label}>DN: </Text></View>
            <View style={styles.textView}><Text style={styles.text}>{dataNascimento}</Text></View>
          </View>
          <View style={styles.item}>
            <View style={styles.labelView}><Text style={styles.label}>Idade: </Text></View>
            <View style={styles.textView}><Text style={styles.text}>{idade}</Text></View>
          </View>
          <View style={styles.item}>
            <View style={styles.labelView}><Text style={styles.label}>Sexo: </Text></View>
            <View style={styles.textView}><Text style={styles.text}>{sexo}</Text></View>
          </View>

        </View>
        <View style={[styles.row]}>
          <View style={[styles.item, {maxWidth: '33%'}]}>
            <View style={styles.labelView}><Text style={styles.label}>Profissão: </Text></View>
            <View style={[styles.textView, {maxWidth: '82%'}]}><Text style={styles.text}>{profissao}</Text></View>
          </View>
          <View style={[styles.item, {maxWidth: '33%'}]}>
            <View style={styles.labelView}><Text style={styles.label}>Hospital: </Text></View>
            <View style={[styles.textView, {maxWidth: '82%'}]}><Text style={styles.text}>{hospital}</Text></View>
          </View>
          <View style={[styles.item, {maxWidth: '33%'}]}>
            <View style={styles.labelView}><Text style={styles.label}>Convênio: </Text></View>
            <View style={[styles.textView, {maxWidth: '82%'}]}><Text style={styles.text}>{convenio}</Text></View>
          </View>
        </View>
        <View style={[styles.row]}>
          <View style={[styles.item, {maxWidth: '66%'}]}>
            <View style={styles.labelView}><Text style={styles.label}>Procedimentos: </Text></View>
            <View style={[styles.textView, {maxWidth: '85%'}]}><Text style={[styles.text]}>{procedimentos}</Text></View>
          </View>
          <View style={[styles.item, {maxWidth: '33%'}]}>
            <View style={styles.labelView}><Text style={styles.label}>Cirurgiã(o): </Text></View>
            <View style={[styles.textView, {maxWidth: '80%'}]}><Text style={styles.text}>{cirurgiao}</Text></View>
          </View>
        </View>
      </View>
{/* --> ANTROPOMETRIA <-- */}
      <View style={styles.block}>
         <View style={styles.row}>
            <View style={styles.item}>
              <View style={styles.labelView}><Text style={styles.label}>Peso(kg) </Text></View>
              <View style={styles.textView}><Text style={styles.text}>{peso}</Text></View>
            </View>
            <View style={styles.item}>
              <View style={styles.labelView}><Text style={styles.label}>Altura(cm) </Text></View>
              <View style={styles.textView}><Text style={styles.text}>{altura}</Text></View>
            </View>
          </View>
          <View style={styles.row}>
             <View style={styles.item}>
               <View style={styles.labelView}><Text style={styles.label}>IMC(kg/m²) </Text></View>
               <View style={styles.textView}><Text style={styles.text}>{imc}</Text></View>
             </View>
             <View style={styles.item}>
               <View style={styles.labelView}><Text style={styles.label}>P. Ajustado </Text></View>
               <View style={styles.textView}><Text style={styles.text}>{pesoAjustado}</Text></View>
             </View>
           </View>
           <View style={styles.row}>
             <View style={styles.item}>
               <View style={styles.labelView}><Text style={styles.label}>Peso Ideal </Text></View>
               <View style={styles.textView}><Text style={styles.text}>{pesoIdeal}</Text></View>
             </View>
             <View style={styles.item}>
               <View style={styles.labelView}><Text style={styles.label}>P. Predito </Text></View>
               <View style={styles.textView}><Text style={styles.text}>{pesoPredito}</Text></View>
             </View>
           </View>
        </View>
      </View>
{/* --> HISTÓRIA CIRÚRGICA PRÉVIA <-- */}
  <View>
    <Text style={styles.subtitle}>HISTÓRIA CIRÚRGICA PRÉVIA</Text>
      <View style={styles.block}>
        <View style={styles.item}>
          <View style={styles.labelView}><Text style={styles.label}>Procedimentos Prévios: </Text></View>
          <View style={[styles.textView, {maxWidth: '85%'}]}><Text style={styles.text}>{displayInfo(procedimentosPrevios, procedimentosPadrao)}</Text></View>
        </View>
        <View style={styles.item}>
          <View style={styles.labelView}><Text style={styles.label}>Anestesias Prévias: </Text></View>
          <View style={[styles.textView, {maxWidth: '85%'}]}><Text style={styles.text}>{displayInfo(anestesiasPrevias, anestesiasPadrao)}</Text></View>
        </View>
        <View style={styles.item}>
          <View style={styles.labelView}><Text style={styles.label}>Eventos Adversos: </Text></View>
          <View style={[styles.textView, {maxWidth: '85%'}]}><Text style={styles.text}>{displayInfo(eventosAdversos, adversosPadrao)}</Text></View>
        </View>
      </View>
  </View>
{/* --> ALERGIAS <-- */}
    <View>
      <Text style={styles.subtitle}>ALERGIAS</Text>
      <View style={alergias ? [styles.block, { borderColor: 'darkred' }] : styles.block}>
        <View style={styles.item}>
          <View style={styles.textView}><Text style={styles.text}>{displayInfo(alergias, alergiasPadrao)}</Text></View>
        </View>
      </View>
    </View>
{/* --> COMORBIDADES <-- */}
  <View>
    <Text style={styles.subtitle}>COMORBIDADES</Text>
      <View style={styles.block}>
        <View style={styles.item}>
          <View style={styles.textView}><Text style={styles.text}>{displayInfo(comorbidade === 'true', comorbidadesPadrao, "")}</Text></View>
          <View style={styles.textView}>
            <Text>
              {listaDoencas.map((sistema, index) => (
                <Text key={index}>
                  <Text style={styles.text}>
                    {listaDoencas[index][Object.keys(sistema)[0]].map(doenca =>
                      (displayInfo(eval(doenca[0]), "", (doenca[1] + ",  "))))
                    }
                  </Text>
                </Text>
              ))}
              <Text style={styles.text}>
                {displayInfo(outrasComorbidades) + "  "}
              </Text>
            </Text>
          </View>
        </View>
      </View>
    </View>
{/* --> MEDICAMENTOS <-- */}
<View>
<Text style={styles.subtitle}>MEDICAMENTOS</Text>
      <View style={styles.block }>
        <View style={styles.item}>
          <View style={styles.textView}><Text style={styles.text}>{displayInfo(medicamentos, medicamentosPadrao)}</Text></View>
        </View>
      </View>
</View>
{/* --> EXAME FÍSICO <-- */}
<View>
<Text style={styles.subtitle}>EXAME FÍSICO</Text>
  <View style={styles.row}>
    <View style={[styles.block, { flexGrow: 2, maxWidth: '82%' }]}>
      <View style={styles.item}>
        <View style={styles.textView}><Text style={styles.text}>{displayInfo(exameFisico, examePadrao)}</Text></View>
      </View>
    </View>
    <View style={styles.block}>
       <View style={styles.row}>
          <View style={styles.itemRightMargin}>
            <View style={styles.labelView}><Text style={styles.label}>PA(mmHg) </Text></View>
            <View style={styles.textView}><Text style={styles.text}>{pa}</Text></View>
          </View>
          <View style={styles.item}>
            <View style={styles.labelView}><Text style={styles.label}>FC(bpm) </Text></View>
            <View style={styles.textView}><Text style={styles.text}>{fc}</Text></View>
          </View>
        </View>
        <View style={styles.row}>
           <View style={styles.itemRightMargin}>
             <View style={styles.labelView}><Text style={styles.label}>FR(irpm) </Text></View>
             <View style={styles.textView}><Text style={styles.text}>{fr}</Text></View>
           </View>
           <View style={styles.item}>
             <View style={styles.labelView}><Text style={styles.label}>Temp(°C) </Text></View>
             <View style={styles.textView}><Text style={styles.text}>{temp}</Text></View>
           </View>
         </View>
         <View style={styles.row}>
           <View style={styles.itemRightMargin}>
             <View style={styles.labelView}><Text style={styles.label}>SpO2(%) </Text></View>
             <View style={styles.textView}><Text style={styles.text}>{spo2}</Text></View>
           </View>
           <View style={styles.item}>
             <View style={styles.labelView}><Text style={styles.label}>Dor(0-10) </Text></View>
             <View style={styles.textView}><Text style={styles.text}>{dor}</Text></View>
           </View>
         </View>
      </View>
    </View>
  </View>
{/* --> VIAS AÉREAS <-- */}
<View>
  <Text style={styles.subtitle}>VIAS AÉREAS</Text>
    <View style={styles.block }>
      <View style={[styles.row, { justifyContent: 'space-evenly'}]}>
         <View style={styles.itemRightMargin}>
           <View style={styles.labelView}><Text style={styles.label}>Mallampati: </Text></View>
           <View style={styles.textView}><Text style={styles.text}>{mallampati}</Text></View>
         </View>
         <View style={styles.itemRightMargin}>
           <View style={styles.labelView}><Text style={styles.label}>Distância Tireomentoniana: </Text></View>
           <View style={styles.textView}><Text style={styles.text}>{dtm}</Text></View>
         </View>
         <View style={styles.itemRightMargin}>
           <View style={styles.labelView}><Text style={styles.label}>Distância Esternomentoniana: </Text></View>
           <View style={styles.textView}><Text style={styles.text}>{dem}</Text></View>
         </View>
         <View style={styles.itemRightMargin}>
            <View style={styles.labelView}><Text style={styles.label}>Abertura Oral: </Text></View>
            <View style={styles.textView}><Text style={styles.text}>{aberturaOral}</Text></View>
          </View>
          <View style={styles.itemRightMargin}>
            <View style={styles.labelView}><Text style={styles.label}>Mobilidade Cervical: </Text></View>
            <View style={styles.textView}><Text style={styles.text}>{mobilidadeCervical}</Text></View>
          </View>
          <View style={styles.item}>
            <View style={styles.labelView}><Text style={styles.label}>Prótese Dentária? </Text></View>
            <View style={styles.textView}><Text style={styles.text}>{proteseDentaria}</Text></View>
          </View>
        </View>
        <View style={styles.row}>
          <View style={styles.item}>
            <View style={styles.labelView}><Text style={styles.label}>Risco de Via Aérea Difícil? </Text></View>
            <View style={styles.textView}><Text style={styles.text}>{(vad === 'true') && 'SIM'}</Text></View>
            <View style={styles.textView}><Text style={styles.text}>{(vad === 'false') && 'NÃO'}</Text></View>
          </View>
        </View>
    </View>
  </View>
{/* --> EXAMES <-- */}
<View>
  <Text style={styles.subtitle}>EXAMES COMPLEMENTARES</Text>
    <View style={styles.block }>
      <View style={styles.fixedRow}>
         <View style={styles.itemExam}>
           <View style={styles.labelView}><Text style={styles.label}>Hb </Text></View>
           <View style={styles.textView}><Text style={styles.text}>{hb}</Text></View>
         </View>
         <View style={styles.itemExam}>
           <View style={styles.labelView}><Text style={styles.label}>Ht </Text></View>
           <View style={styles.textView}><Text style={styles.text}>{ht}</Text></View>
         </View>
         <View style={styles.itemExam}>
           <View style={styles.labelView}><Text style={styles.label}>Hm </Text></View>
           <View style={styles.textView}><Text style={styles.text}>{hm}</Text></View>
         </View>
         <View style={styles.itemExam}>
            <View style={styles.labelView}><Text style={styles.label}>Leuco </Text></View>
            <View style={styles.textView}><Text style={styles.text}>{leuco}</Text></View>
          </View>
          <View style={styles.itemExam}>
            <View style={styles.labelView}><Text style={styles.label}>Plt </Text></View>
            <View style={styles.textView}><Text style={styles.text}>{plt}</Text></View>
          </View>
          <View style={styles.itemExam}>
            <View style={styles.labelView}><Text style={styles.label}>Fibrinogênio </Text></View>
            <View style={styles.textView}><Text style={styles.text}>{fibrinogenio}</Text></View>
          </View>
        </View>
        <View style={styles.fixedRow}>
           <View style={styles.itemExam}>
             <View style={styles.labelView}><Text style={styles.label}>TC </Text></View>
             <View style={styles.textView}><Text style={styles.text}>{tc}</Text></View>
           </View>
           <View style={styles.itemExam}>
             <View style={styles.labelView}><Text style={styles.label}>TS </Text></View>
             <View style={styles.textView}><Text style={styles.text}>{ts}</Text></View>
           </View>
           <View style={styles.itemExam}>
             <View style={styles.labelView}><Text style={styles.label}>TP </Text></View>
             <View style={styles.textView}><Text style={styles.text}>{tp}</Text></View>
           </View>
           <View style={styles.itemExam}>
              <View style={styles.labelView}><Text style={styles.label}>INR </Text></View>
              <View style={styles.textView}><Text style={styles.text}>{inr}</Text></View>
            </View>
            <View style={styles.itemExam}>
              <View style={styles.labelView}><Text style={styles.label}>TTPa </Text></View>
              <View style={styles.textView}><Text style={styles.text}>{ttpa}</Text></View>
            </View>
            <View style={styles.itemExam}>
              <View style={styles.labelView}><Text style={styles.label}>Ativ Protrombina </Text></View>
              <View style={styles.textView}><Text style={styles.text}>{ap}</Text></View>
            </View>
          </View>
          <View style={styles.fixedRow}>
             <View style={styles.itemExam}>
               <View style={styles.labelView}><Text style={styles.label}>Uréia </Text></View>
               <View style={styles.textView}><Text style={styles.text}>{ureia}</Text></View>
             </View>
             <View style={styles.itemExam}>
               <View style={styles.labelView}><Text style={styles.label}>Creat </Text></View>
               <View style={styles.textView}><Text style={styles.text}>{creat}</Text></View>
             </View>
             <View style={styles.itemExam}>
               <View style={styles.labelView}><Text style={styles.label}>Na </Text></View>
               <View style={styles.textView}><Text style={styles.text}>{na}</Text></View>
             </View>
             <View style={styles.itemExam}>
                <View style={styles.labelView}><Text style={styles.label}>K </Text></View>
                <View style={styles.textView}><Text style={styles.text}>{k}</Text></View>
              </View>
              <View style={styles.itemExam}>
                <View style={styles.labelView}><Text style={styles.label}>Ca </Text></View>
                <View style={styles.textView}><Text style={styles.text}>{ca}</Text></View>
              </View>
              <View style={styles.itemExam}>
                <View style={styles.labelView}><Text style={styles.label}>Magnésio </Text></View>
                <View style={styles.textView}><Text style={styles.text}>{mg}</Text></View>
              </View>
            </View>
            <View style={styles.fixedRow}>
               <View style={styles.itemExam}>
                 <View style={styles.labelView}><Text style={styles.label}>Glicemia </Text></View>
                 <View style={styles.textView}><Text style={styles.text}>{glicemia}</Text></View>
               </View>
               <View style={styles.itemExam}>
                 <View style={styles.labelView}><Text style={styles.label}>Hba1c </Text></View>
                 <View style={styles.textView}><Text style={styles.text}>{hba1c}</Text></View>
               </View>
               <View style={styles.itemExam}>
                 <View style={styles.labelView}><Text style={styles.label}>AST </Text></View>
                 <View style={styles.textView}><Text style={styles.text}>{ast}</Text></View>
               </View>
               <View style={styles.itemExam}>
                  <View style={styles.labelView}><Text style={styles.label}>ALT </Text></View>
                  <View style={styles.textView}><Text style={styles.text}>{alt}</Text></View>
                </View>
                <View style={styles.itemExam}>
                  <View style={styles.labelView}><Text style={styles.label}>Bilirrubinas </Text></View>
                  <View style={styles.textView}><Text style={styles.text}>{bil}</Text></View>
                </View>
                <View style={styles.itemExam}>
                  <View style={styles.labelView}><Text style={styles.label}>Proteínas </Text></View>
                  <View style={styles.textView}><Text style={styles.text}>{prot}</Text></View>
                </View>
              </View>
              { ecg ?
                <View style={styles.item}>
                  <View style={[styles.labelView, {width: 25}]}><Text style={styles.label}>ECG: </Text></View>
                  <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>{ecg}</Text></View>
                </View>  : null
              }
              { eco ? (
                <View style={styles.item}>
                  <View style={[styles.labelView, {width: 25}]}><Text style={styles.label}>ECO: </Text></View>
                  <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>{eco}</Text></View>
                </View> ) : null
              }
              { te ?
                <View style={styles.item}>
                  <View style={[styles.labelView, {width: 25}]}><Text style={styles.label}>TE: </Text></View>
                  <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>{te}</Text></View>
                </View>  : null
              }
              { radiografia ?
                <View style={styles.item}>
                <View style={[styles.labelView]}><Text style={styles.label}>Radiografia: </Text></View>
                <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>{radiografia}</Text></View>
                </View>  : null
              }
              { outrosExames ?
                <View style={styles.item}>
                  <View style={[styles.labelView, {width: 35}]}><Text style={styles.label}>Outros: </Text></View>
                  <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>{outrosExames}</Text></View>
                </View>  : null
              }
      </View>
    </View>
      { avalEspecialidades ?
        <View style={styles.block}>
          <View style={styles.item}>
            <View style={styles.labelView}><Text style={styles.label}>Avaliações: </Text></View>
            <View style={[styles.textView, {maxWidth: '85%'}]}><Text style={styles.text}>{avalEspecialidades}</Text></View>
          </View>
        </View>  : null
      }
      <Text style={styles.subtitle}>ANOTAÇÕES</Text>
      <View style={styles.block}>
      { anotacoes ?
          <View style={styles.item}>
            <View style={[styles.textView, {maxWidth: '85%'}]}><Text style={styles.text}>{anotacoes}</Text></View>
          </View> : null
      }
      { (broncoaspiracao === 'true') ?
          <View style={styles.item}>
            <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>Risco de Broncoaspiração: SIM </Text></View>
          </View>  : 
          <View style={styles.item}>
          <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>Risco de Broncoaspiração: NÃO</Text></View>
        </View>
      }
      { (trombose === 'true') ?
          <View style={styles.item}>
            <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>Risco de Trombose Venosa: SIM</Text></View>
          </View>  : 
          <View style={styles.item}>
          <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>Risco de Trombose Venosa: NÃO</Text></View>
        </View>
      }
      { (sangramento === 'true') ?
          <View style={styles.item}>
            <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>Risco de Sangramento: SIM</Text></View>
          </View>  : 
          <View style={styles.item}>
          <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>Risco de Sangramento: NÃO</Text></View>
        </View>
      }
      { hemocomponentes ?
          <View style={styles.item}>
            <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>{`Reservar hemocomponentes ${displayInfo(hemoTexto)}`}</Text></View>
          </View>  : 
          <View style={styles.item}>
          <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>{`Solicitação de hemocomponentes: NÃO`}</Text></View>
        </View>
      }
      { uti ?
          <View style={styles.item}>
            <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>Solicitar reserva de UTI para o pós-operatório</Text></View>
          </View>  : 
          <View style={styles.item}>
          <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>UTI no pós-operatório: NÃO</Text></View>
        </View>
      }
      </View>

{/* --> ORIENTAÇÕES <-- */}
<View>
  <Text style={styles.subtitle}>ORIENTAÇÕES</Text>
      <View style={styles.block }>
        <View style={styles.item}>
          <View style={styles.textView}><Text style={styles.text}>{displayInfo(orientacoes)}</Text></View>
        </View>
        { apto ?
          <View style={styles.item}>
            <View style={[styles.textView, {maxWidth: '90%'}]}><Text style={styles.text}>Apto para procedimento proposto</Text></View>
          </View>  : null
        }

      </View>
    </View>
{/* --> ANESTESIA PROPOSTA <-- */}
<View style={styles.block}>
  <View style={[styles.row, {justifyContent: 'flex-start'}]}>
    <View style={[styles.item, {width: '48%'}]}>
      <View style={styles.labelView}><Text style={styles.label}>Jejum Pré-operatório: </Text></View>
      <View style={[styles.textView, {width: '75%'}]}><Text style={styles.text}>{jejum}</Text></View>
    </View>
    <View style={[styles.item, {width: '48%'}]}>
      <View style={styles.labelView}><Text style={styles.label}>Anestesia Proposta: </Text></View>
      <View style={[styles.textView, {width: '75%'}]}><Text style={styles.text}>{anestesiaProposta}</Text></View>
    </View>
  </View>
</View>
{/* --> PRESCRIÇÃO <-- */}
<View>
<Text style={styles.subtitle}>PRESCRIÇÃO PRÉ-ANESTÉSICA</Text>
  <View style={styles.row}>
    <View style={[styles.block, { width: '72%' }]}>
      <View style={styles.item}>
        <View style={styles.textView}><Text style={styles.text}>{displayInfo(prescricao)}</Text></View>
      </View>
    </View>
    <View style={[styles.block, { width: '27%', padding:2}]}>
      <View style={[styles.row, {height: 50}]}>

      <View style={styles.item}>
        <View style={[styles.textView, {textAlign: 'center'}]}>
          <Text style={[styles.text, {fontSize: '15pt', marginTop: 18}]}>
            ASA: {displayInfo(asa, "")}
          </Text>
        </View>
      </View>

      </View>
    </View>
  </View>
</View>

<View style={styles.row}>

    <View style={[styles.block, {width: '50%', fontSize: '13pt'}]}>

     <View style={styles.labelView}>
            <Text style={styles.stamp}>
              CARIMBO E ASSINATURA
            </Text>
            <Text style={{marginTop: 28, fontSize: '10pt'}}>
         ______________________, ____/____/______ , ___:___
            </Text>
            <Text style={[styles.stamp, {marginTop: 2}]}>
              {groupName ? groupName : (nomeExibicao ? nomeExibicao : 'MÉDICO ANESTESIOLOGISTA')}
              {!groupName && crm && ` CRM: ${crm}`}

            </Text>
          </View>
    </View>
    <View style={[styles.block, {width: '50%', fontSize: '13pt'}]}>

<View style={styles.labelView}>
       <Text style={[styles.stamp]}>
         DECLARO QUE AS INFORMAÇÕES SÃO VERDADEIRAS
       </Text>
       <Text style={{marginTop: 28, fontSize: '10pt'}}>
         ______________________, ____/____/______ , ___:___
       </Text>

       <Text style={[styles.stamp, {marginTop: 2}]}>
         Assinatura do paciente ou responsável
       </Text>
     </View>
</View>
</View>
  </Page>
</Document>
);

export default fichaPdf
